<template>
  <div class="books-container">
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row hidden-row"></div>
        <div class="row">
          <div class="col-12 my-5">
            <h5>
              <unicon
                :name="'books'"
                :fill="secCol"
                style="margin-right: 8px;"
              />
              <span>Biblioteca</span>
            </h5>
          </div>
        </div>
        <div class="row pb-4">
          <!-- <div class="col-md-3">
            <img src="https://placehold.it/100x100" />
          </div> -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-12 h5 text-logo">
                Biblioteca
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 subtitle">
                <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
                vel lobortis nisl. In id cursus neque, sed luctus leo. -->
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-6">
                <CustomInput class="pointer" :icon="'fa fa-search'">
                  <input
                    type="text"
                    slot="input"
                    placeholder="Buscar libro por título"
                    v-model="bookTitle"
                    @change="filter"
                  />
                </CustomInput>
              </div>
              <div class="col-md-6">
                <DropSelect
                  v-bind="selectLevel"
                  v-model="selectLevel.selected"
                  :zIndex="3"
                  v-if="selectLevel.options.length"
                />
                <span class="text-gray" v-if="!selectLevel.options.length">
                  Cargando lista de grados...
                </span>
              </div>
              <!-- <div class="col-md-6">
                <CustomInput :icon="'fa fa-filter'">
                  <input type="text" slot="input" placeholder="Filtrar por" />
                </CustomInput>
              </div> -->
            </div>
          </div>
        </div>

        <div class="row" v-if="books.length">
          <template v-for="(book, i) in books">
            <BookCard
              :key="i"
              :data="book"
              @openBookModal="openBookModal(book)"
            />
          </template>
        </div>
        <div class="row" v-if="books.length === 0 && !loading">
          <div class="col text-center text-gray">
            No hay libros para mostrar
          </div>
        </div>

        <div class="row" v-if="loading">
          <div class="col-12 text-center">
            <Spinner />
          </div>
        </div>

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          :sizeList="sizeList"
          v-if="books.length"
          @setPage="setPage"
          @setSize="setSize"
        />

        <div class="row">
          <FooterComponent />
        </div>

        <BookModal
          :data="modalData"
          v-if="showModal.bookModal"
          @close="showModal.bookModal = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomInput from "@/components/CustomInput";
import FooterComponent from "@/components/Footer";
import BookCard from "@/components/Books/BookCard";
import Pagination from "@/components/Pagination";
import BookModal from "@/components/Books/BookModal";
import Spinner from "@/components/Spinner";
import DropSelect from "@/components/DropSelect";

export default {
  name: "Books",
  components: {
    CustomInput,
    FooterComponent,
    BookCard,
    Pagination,
    BookModal,
    Spinner,
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      loading: false,
      secCol,
      showModal: {
        bookModal: false,
      },
      books: [],
      currentPage: 0,
      totalPages: null,
      sizeList: 10,
      modalData: null,
      bookTitle: "",
      selectLevel: {
        id: "level",
        supTitle: "Tipo de lector",
        placeholder: "Elige por rango de edad",
        selected: "",
        icon: "graduation-hat",
        textKey: "name",
        valueKey: "ordinalGrade",
        options: [],
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData", "userData"]),
  },
  watch: {
    "selectLevel.selected"() {
      this.filter();
    },
    userData() {
      this.getFilters();
    },
  },
  methods: {
    getOptionNameByAge(age) {
      switch (age) {
        case 6:
          return "Lector inicial (a partir de 6 años)";
        case 9:
          return "Lector intrépido (a partir de 9 años)";
        case 12:
          return "Lector Independiente (a partir de 12 años)";
        case 14:
          return "Lector juvenil ( a partir de 14 años)";
        case 16:
          return "Lector reflexivo (a partir de 16 años)";
        default:
          return null;
      }
    },
    filter() {
      this.currentPage = 0;
      this.getBooksList();
    },
    openBookModal(data) {
      this.modalData = data;
      this.showModal.bookModal = true;
    },
    setPage(page) {
      this.currentPage = page;
      this.getBooksList();
    },
    setSize(size) {
      this.sizeList = size;
      this.currentPage = 0;
      this.getBooksList();
    },
    async getBooksList() {
      this.loading = true;
      let apiUrl = `${this.dataUrl}/book/getBookListByTittle?userId=${
        this.teacherData.id
      }&grade=${this.selectLevel.selected}&matchGradeAndAge=${true}&tittle=${
        this.bookTitle
      }&number=${this.currentPage}&size=${this.sizeList}`;
      this.books = [];

      try {
        let { data } = await this.axios.get(apiUrl);
        this.books = data.content.content;
        this.totalPages = data.content.totalPages;
      } catch (error) {
        console.error("Error al obener libros", error);
      } finally {
        this.loading = false;
      }
    },
    async getFilters() {
      let apiUrl = `${this.dataUrl}/course/getAllGradeByCountryId?countryId=${this.userData.school.baseCountryId}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.selectLevel.options = data.content
            .map(grade => ({
              ...grade,
              name: this.getOptionNameByAge(grade.age),
            }))
            .filter(grade => !!grade.name);

          this.selectLevel.options.unshift({
            ordinalGrade: "",
            name: "Todos",
          });
        } else {
          this.$notify({
            title: ["Ocurrió un error"],
            type: "danger",
          });
        }
      } catch (error) {
        console.error("Error al obtener grados", error);
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      }
    },
  },
  mounted() {
    if (this.userData) this.getFilters();
    this.getBooksList();
  },
};
</script>

<style lang="scss" scoped>
.books-container {
  min-height: calc(100vh - 304px);
}

.subtitle {
  font-size: 14px;
}
</style>
